<template>
  <div class="container">
    <div class="row">
      <div class="col-1">
        <!-- space -->
      </div>
      <div class="col-10 mt-5 text-center">
        <img src="assets/ParkingConfirmation.png" alt="" height="120">
        <br>
        <br>
        <form>
          <div class="text-center">
            <img src="assets/confirmedCheck.png" alt="" height="210">
          </div>
          <br>
          <div class="row fixed-bottom pb-5">
            <div class="col">
              <!-- space  -->
            </div>
            <div class="col text-right">
              <router-link to="/"><img src="assets/button/returnHome.png" alt="" height="33"></router-link>
            </div>
          </div>
        </form>
      </div>
      <div class="col-1">
        <!-- space -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ParkingConfirmation"
}
</script>

<style lang="css" scoped>
</style>
